import React, { useCallback, useEffect, useState } from 'react';
import Autocomplete from 'fe-design-base/atoms/Autocomplete';
import Box from 'fe-design-base/atoms/Box';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx } = cxHelpers('EmployeeSelect');

const EmployeeSelect = ({ employees, setEmployeeJobId, employeeJobId }) => {
  const getEmployeeFromId = useCallback(
    id => employees.find(employee => employee.value === id),
    [employees]
  );

  const [value, setValue] = useState('');
  useEffect(() => {
    setValue(getEmployeeFromId(employeeJobId));
  }, [setValue, getEmployeeFromId, employeeJobId]);

  const handleChange = useCallback(
    (_, selection) => {
      if (selection) {
        setEmployeeJobId(selection.value);
        setValue(selection.label);
      } else {
        setEmployeeJobId(null);
        setValue('');
      }
    },
    [setEmployeeJobId]
  );

  return (
    <Box mb={12} className={cx()}>
      <Box grow basis={0}>
        <Autocomplete
          value={value}
          onChange={handleChange}
          options={employees}
          placeholder={toI18n(
            'timecard_modal_v3.header.edit_mode.employee_placeholder'
          )}
          showCaret
          dataTestId="employee-select"
        />
      </Box>
    </Box>
  );
};

EmployeeSelect.propTypes = {
  roleName: PropTypes.string,
  locationName: PropTypes.string,
  editMode: PropTypes.bool,
  newTimecard: PropTypes.bool,
};

export default EmployeeSelect;
